/* Vapor Harness Iceland Edition - page behaviour
   Size selector, gallery, hotspots and the sticky buy bar.
   Guarded so it stays safe when several sections load it. */
(function () {
  if (window.__vaporIceland) return;
  window.__vaporIceland = true;

  function init(root) {
    root = root || document;

    /* ---- gallery ---- */
    root.querySelectorAll('[data-vi-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-vi-gallery-main]');
      gal.querySelectorAll('.thumb').forEach(function (t) {
        if (t.dataset.viBound) return;
        t.dataset.viBound = '1';
        t.addEventListener('click', function () {
          gal.querySelectorAll('.thumb').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          t.setAttribute('aria-pressed', 'true');
          if (main && t.dataset.src) { main.src = t.dataset.src; }
        });
      });
    });

    /* ---- size selector ---- */
    root.querySelectorAll('[data-vi-sizes]').forEach(function (wrap) {
      if (wrap.dataset.viBound) return;
      wrap.dataset.viBound = '1';
      var scope = wrap.closest('[data-vi-product]') || root;
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('.size');
        if (!b || b.disabled) return;
        wrap.querySelectorAll('.size').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        var out = function (sel, val) {
          var el = scope.querySelector(sel);
          if (el && val) { el.textContent = val; }
        };
        out('[data-vi-size-out]', b.dataset.size);
        out('[data-vi-bar-out]', b.dataset.bar);
        out('[data-vi-upc-out]', b.dataset.upc);
        var input = scope.querySelector('[data-vi-variant-input]');
        if (input && b.dataset.variant) {
          input.value = b.dataset.variant;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    /* ---- hotspots ---- */
    root.querySelectorAll('[data-vi-hotspots]').forEach(function (block) {
      if (block.dataset.viBound) return;
      block.dataset.viBound = '1';
      var total = block.querySelectorAll('.hot-list button').length;
      function show(n) {
        var src = block.querySelector('.hot-list button[data-hot="' + n + '"]');
        if (!src) return;
        block.querySelectorAll('[data-hot]').forEach(function (el) {
          el.setAttribute('aria-pressed', el.dataset.hot === n ? 'true' : 'false');
        });
        var set = function (sel, val) {
          var el = block.querySelector(sel);
          if (el) { el.textContent = val || ''; }
        };
        var nr = block.querySelector('[data-hot-nr]');
        if (nr) { nr.textContent = ('0' + n).slice(-2); }
        set('[data-hot-title]', src.dataset.title);
        set('[data-hot-text]', src.dataset.text);
        set('[data-hot-spec]', src.dataset.spec);
      }
      block.querySelectorAll('[data-hot]').forEach(function (el) {
        el.addEventListener('click', function () { show(el.dataset.hot); });
      });
      var totalEl = block.querySelector('[data-hot-total]');
      if (totalEl) { totalEl.textContent = ('0' + total).slice(-2); }
    });

    /* ---- sticky buy bar ---- */
    var bar = root.querySelector('[data-vi-sticky]');
    var anchor = document.querySelector('[data-vi-sticky-anchor]');
    if (bar && anchor && 'IntersectionObserver' in window && !bar.dataset.viBound) {
      bar.dataset.viBound = '1';
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('on', !entries[0].isIntersecting);
      }, { rootMargin: '-40% 0px 0px 0px' }).observe(anchor);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* theme editor: re-bind when a section is reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    delete window.__vaporIcelandBound;
    init(e.target);
  });
})();
